/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Message } from '../../models/message';

export interface CreateMessageStaff$Params {
      body: Message
}

export function createMessageStaff(http: HttpClient, rootUrl: string, params: CreateMessageStaff$Params, context?: HttpContext): Observable<StrictHttpResponse<Message>> {
  const rb = new RequestBuilder(rootUrl, createMessageStaff.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Message>;
    })
  );
}

createMessageStaff.PATH = '/messagesStaff';
